import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { BoldText, HXSectionTitle, LightText, Subtitle as SharedSubtitle } from "./HXDesktopPage.styles";
import { FlexRowDiv, FlexRowSpaceBetween } from "./common.styles";
export const Parent = styled.div `
    display: flex;
    padding: 24px 0 40px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`;
export const Title = styled(HXSectionTitle) ``;
export const Subtitle = styled(SharedSubtitle) `
    font-size: ${fontSizes.LARGE};
`;
export const Text = styled(LightText) ``;
export const TextBold = styled(BoldText) ``;
export const TextLarge = styled(Text) `
    font-size: ${fontSizes.GIANT};
    color: ${colors.black_main};
`;
export const TabTitleBar = styled(FlexRowSpaceBetween) `
    padding: 24px 0px;
`;
export const TabTitleButtons = styled(FlexRowDiv) `
    align-items: center;
    gap: 16px;
`;
